import clsx from "~/util/html/style";
import { createMemo, mergeProps, type ParentProps, Show } from "solid-js";

type DividerProps = ParentProps<{
  orientation?: "horizontal" | "vertical";
  weight?: "default" | "bold";
  variant?: "default" | "primary";
  // Section-style labels read uppercase; pass false for sentence-length labels.
  uppercase?: boolean;
  class?: string;
}>;

export function Divider(_props: DividerProps) {
  const props = mergeProps(
    { orientation: "horizontal", weight: "default", variant: "default", uppercase: true },
    _props,
  );

  const lineClass = createMemo(() =>
    clsx(
      "flex-1",
      props.variant === "primary" ? "bg-brand-primary/40" : "bg-brand-subtle",
      props.orientation === "horizontal"
        ? props.weight === "bold"
          ? "h-0.5"
          : "h-[0.5px]"
        : props.weight === "bold"
          ? "w-0.5"
          : "w-[0.5px]",
    ),
  );

  return (
    <div
      class={clsx(
        "flex",
        props.orientation === "horizontal"
          ? "w-full items-center"
          : "flex-col justify-center self-stretch",
        props.class,
      )}
    >
      <Show when={props.children} fallback={<div class={lineClass()} />}>
        <div class={lineClass()} />
        <div
          class={clsx(
            "px-2 text-xs font-semibold",
            props.uppercase && "uppercase",
            props.variant === "primary" ? "text-brand-primary" : "text-typography-secondary",
          )}
        >
          {props.children}
        </div>
        <div class={lineClass()} />
      </Show>
    </div>
  );
}
